module.exports = __webpack_public_path__ + "img/SEC.fe668e5.svg";